import { queriesAuthorizations } from "@query";
import { useSession } from "@hooks/useSession";
import { AuthorizationGranteeType } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { accountAccessService } from "@services/accountAccessService";

export const useAccountAccess = () => {
  const { personId, accountId } = useSession();

  const queryGrants = queriesAuthorizations.listAuthorizations.useQuery(
    {
      // TODO: add filter by accountId
      filter: {
        granteeType: { eq: AuthorizationGranteeType.PERSON },
        granteeId: { eq: personId }
      }
    },
    { enabled: !!personId && !!accountId }
  );

  const grants = queryGrants.data?.data;

  return useMemo(
    () => accountAccessService.resolveAccess(accountId, grants ?? []),
    [accountId, grants]
  );
};
